import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface UIState {
  // UI State (perfect for Zustand)
  showDefinition: boolean;
  debugMode: boolean;
  
  // Form State (ephemeral, good for Zustand)
  newWord: string;
  newDefinition: string;
  
  // Actions
  toggleDefinition: () => void;
  setShowDefinition: (show: boolean) => void;
  updateForm: (field: 'word' | 'definition', value: string) => void;
  clearForm: () => void;
  toggleDebug: () => void;
  resetDefinitionState: () => void; // Helper for after answer submission
}

export const useAppStore = create<UIState>()(
  devtools(
    (set) => ({
      // Initial state
      showDefinition: false,
      newWord: '',
      newDefinition: '',
      debugMode: false,
      
      // Actions
      toggleDefinition: () => 
        set((state) => ({ showDefinition: !state.showDefinition }), false, 'toggleDefinition'),
      
      setShowDefinition: (show) => 
        set({ showDefinition: show }, false, 'setShowDefinition'),
      
      updateForm: (field, value) => 
        set(
          field === 'word' 
            ? { newWord: value }
            : { newDefinition: value },
          false,
          `updateForm:${field}`
        ),
      
      clearForm: () => 
        set({ newWord: '', newDefinition: '' }, false, 'clearForm'),
      
      toggleDebug: () => 
        set((state) => ({ debugMode: !state.debugMode }), false, 'toggleDebug'),
        
      resetDefinitionState: () =>
        set({ showDefinition: false }, false, 'resetDefinitionState'),
    }),
    { name: 'ui-store' }
  )
);